var map = {
	"./createAssessment.gif": 63834,
	"./inviteCandidate.gif": 28042,
	"./inviteCoworker.gif": 77675,
	"./newProject.gif": 74377,
	"./projectCard.gif": 55881,
	"./view-result.gif": 81055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49575;